const APP_VERSION = '2.0';

export default {
    APP_VERSION
};
